import React from 'react';
import { Radio, Input } from 'semantic-ui-react';

const percentageOptions = [15, 18, 20, 'Custom'];

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percentage: 18,
    };

    this.handlePercentageChange = this.handlePercentageChange.bind(this);
    this.convertPercentageOfToDecimal = this.convertPercentageOfToDecimal.bind(this);
    this.formatPercentageLabel = this.formatPercentageLabel.bind(this);
    this.emitTipChange = this.emitTipChange.bind(this);
  }

  componentDidMount() {
    this.emitTipChange();
  }

  convertPercentageOfToDecimal(amount, percentage) {
    return (amount * (percentage / 100)).toFixed(2);
  }

  formatPercentageLabel(value) {
    if (value === 'Custom') return 'Custom';
    return `${value}%`;
  }

  handlePercentageChange(e, { value }) {
    this.setState({ percentage: value }, () => {
      this.emitTipChange();
    });
  }

  emitTipChange() {
    const { percentage } = this.state;
    const { handleChange, amount } = this.props;

    if (percentage !== 'Custom') {
      const target = {
        id: 'tip',
        name: 'tip',
        value: this.convertPercentageOfToDecimal(amount, percentage),
      };
      const e = { target };
      handleChange(e, target);
    }
  }

  render() {
    const { handleChange, tip } = this.props;
    const { percentage } = this.state;

    return (
      <div>
        {percentageOptions.map(percent => (
          <Radio
            key={percent}
            name="tip"
            className="tip-button"
            label={this.formatPercentageLabel(percent)}
            value={percent}
            onChange={this.handlePercentageChange}
            checked={percentage === percent}
          />
        ))}
        {percentage === 'Custom' && (
          <Input
            className="tip-input"
            label="$"
            name="tip"
            id="tip"
            step="0.01"
            onChange={handleChange}
            type="number"
            value={tip}
          />
        )}
      </div>
    );
  }
}
